import { FaRegLightbulb } from 'react-icons/fa';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Icon,
  Text,
} from '@chakra-ui/react';
import {
  DisplayAggregateQuestionDto,
  DisplayIndividualQuestionDto,
} from '@keyops-cep/api-client';

import { CopyButton } from '../../../components/ButtonComponents/CopyButton';
import MarkdownDisplay from '../../../components/MarkdownDisplay';
import { ANALYTICS_EVENT_NAME } from '../../../utils/constants/analytics-constants';
import i18n from '../../../utils/i18n';

export type QuestionInsightProps = {
  question: DisplayIndividualQuestionDto | DisplayAggregateQuestionDto;
  questionAnalysisContent: string;
};

export const QuestionInsightsExpandable = ({
  question,
  questionAnalysisContent,
}: QuestionInsightProps) => {
  const content = questionAnalysisContent ?? '';

  return (
    <Accordion
      id="question-insights-expandable"
      data-testid="question-insights-expandable"
      w={'100%'}
      backgroundColor="keyops.lighterOrange"
      borderRadius={'8px 8px 0 0'}
      allowToggle
    >
      <AccordionItem border={'none'}>
        <AccordionButton
          _hover={{ bg: 'none', cursor: 'pointer' }}
          zIndex={10} // Because Flex above blocks the pointer cursor
        >
          <Flex
            direction="row"
            justify={'space-between'}
            align={'center'}
            width="100%"
          >
            <Flex
              direction="row"
              justify={'flex-start'}
              align={'center'}
              gap={1}
            >
              <Icon as={FaRegLightbulb} color="keyops.orange" />
              <Text
                as="h2"
                sx={{
                  textTransform: 'capitalize !important',
                  color: `black !important`,
                  fontWeight: '500 !important',
                }}
              >
                {i18n.t('engagementDetails.questionCards.analysisHeading')}
              </Text>
            </Flex>
            <AccordionIcon color="keyops.darkerBlue" />
          </Flex>
        </AccordionButton>
        <AccordionPanel>
          <Flex direction="row" align={'flex-start'} justify={'space-between'}>
            <MarkdownDisplay source={questionAnalysisContent} />
            <CopyButton
              contentToCopy={content}
              analyticsEventName={
                ANALYTICS_EVENT_NAME.ENGAGEMENT_DETAILS.ANALYSIS_COPY
              }
              analyticstoTrack={{
                engagementId: question.engagementId,
                questionId: question.id,
                position: question.position,
              }}
            />
          </Flex>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
